// extracted by mini-css-extract-plugin
export var closeButton = "_fn-1";
export var closeX = "_fn-3";
export var container = "_fn-0";
export var image = "_fn-2";